// extracted by mini-css-extract-plugin
export default {"setHomePageContainer":"setHomePageContainer_setHomePageContainer__6sbHd"};